import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Provider } from 'mobx-react';
import PasswordChange from './app/signin/PasswordChange';
import PasswordRequest from './app/signin/PasswordRequest';
import RegisterSocial from './app/signin/RegisterSocial';
import Register from './app/signin/Register';
import Logout from './app/logout';
import SignInEmail from './app/signin/SignInEmail';
import ChatSupport from './app/projects/chat';

import AccountContainer from './containers/account/AccountContainer';
import LoginOauth from './shared/login/oauth/loginOauth';
import Info from './containers/infoSeenapse/info';
import SearchPage from './containers/SearchPage';
import NotFound from './content/components/not-found';
import UpdateProfile from './components/updateProfile/Profile';
import Home from './containers/Home';
import Stores from './stores/Stores';
import App from './app';
import EditSeenapse from './containers/editSeenapse/editSeenapse';
import NewSeenapse from './containers/newSeenapse/newSeenapse';
import { TotalNotificationsProvider } from './stores/Notificationstore';
import BeforeGenerateIdeas from './components/detail/BeforeGeneratingIdeas';
import BeforeGeneratingPage from './containers/BeforeGeneratingPage';
import ClimateSolutions from './app/climate';
import ClimateThanksMessage from './app/climate/ClimateThanks';

/*
 Where:
    module is: account, user, notifications
    section is: faves, seenapse, followers and followees
    or if section have with notifications, then is followed, favorite, seenapsed
 */

export default class Routes extends Component {
  render() {
    return (
      <Provider {...Stores}>
        <TotalNotificationsProvider>
          <App>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/login/email" component={SignInEmail} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/update-profile" component={UpdateProfile} />
              <Route exact path="/climate" component={ClimateSolutions} />
              <Route
                exact
                path="/climate/thanks"
                component={ClimateThanksMessage}
              />
              <Route
                exact
                path="/ai/project/chat/:uid"
                component={ChatSupport}
              />
              <Route exact path="/register/social" component={RegisterSocial} />
              <Route
                exact
                path="/before-generating-ideas"
                component={BeforeGenerateIdeas}
              />
              <Route
                exact
                path="/before-generating-ideas"
                component={BeforeGenerateIdeas}
              />
              <Route
                exact
                path="/password/request"
                component={PasswordRequest}
              />
              <Route
                exact
                path="/password/change/:token"
                component={PasswordChange}
              />
              <Route exact path="/:parent/add" component={NewSeenapse} />
              <Route
                exact
                path="/:parent/:child/edit"
                component={EditSeenapse}
              />
              <Route exact path="/:parent/:child" component={Home} />
              <Route exact path="/search/:query" component={SearchPage} />
              <Route exact path="/search/:type/:query" component={SearchPage} />
              <Route
                exact
                path="/search/:type/:query/:parent/:child"
                component={SearchPage}
              />
              <Route
                exact
                path="/before-generating-ideas/:parent/:child"
                component={BeforeGeneratingPage}
              />
              <Route
                exact
                path="/search/:type/:query/:parent/:child/new"
                component={SearchPage}
              />
              <Route
                exact
                path="/login/:type/:userId/:admin/:token"
                component={LoginOauth}
              />

              <Route
                exact
                path="/:module/:userId/:section"
                component={AccountContainer}
              />
              <Route
                exact
                path="/:module/:userId/:section"
                component={AccountContainer}
              />
              <Route
                exact
                path="/:module/:userId/:section/:parent/:child"
                component={AccountContainer}
              />
              <Route exact path="/:info" component={Info} />
              <Route component={NotFound} />
            </Switch>
          </App>
        </TotalNotificationsProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Routes.jsx